import { render, staticRenderFns } from "./FavouriteProductsSection.vue?vue&type=template&id=21b4794f&scoped=true&"
import script from "./FavouriteProductsSection.vue?vue&type=script&lang=ts&"
export * from "./FavouriteProductsSection.vue?vue&type=script&lang=ts&"
import style0 from "./FavouriteProductsSection.vue?vue&type=style&index=0&id=21b4794f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4794f",
  null
  
)

export default component.exports